import { inject, provideAppInitializer } from '@angular/core';

import { OidcAuthService } from '../services/auth';

export function provideAuthentication() {
    return provideAppInitializer(() =>
        (
            (oidcAuthService: OidcAuthService) => () =>
                oidcAuthService.checkAuthenticatedOrLogin()
        )(inject(OidcAuthService))()
    );
}
